import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../components/Converter";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";
import {
  selectSchwingungsObergrenze,
  setSchwingungsObergrenze,
} from "../../../../../store/slices/innereSlice";

function SchwingungsObergrenze() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const schwingungsObergrenze = useSelector(selectSchwingungsObergrenze);

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.upperLimit")}</p>}
      indicesValue={
        <span>
          F<sub>k,O</sub>
        </span>
      }
      inputValue={
        <NumberFormat
          className={getClassName(schwingungsObergrenze)}
          value={schwingungsObergrenze}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setSchwingungsObergrenze(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default SchwingungsObergrenze;
